import React from 'react';
import styled from "styled-components";
import { 
    StyledLink
 } from "./index";


const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;

    a {
        width: 100%;
        margin: 5px 0;
    }

    ${props => props.theme.mediaQueries.medium}{
        a {
            margin: 0 5px 5px 0;
            width: 49%;
        }
    }
`

const ProductsWrapper = ({
    links
}) => {
    
    const renderLinks = (links) => {
        return links.map((link, i) => {
            return (
                <StyledLink
                    key={i}
                    to={link.to}
                >
                    {link.text}
                </StyledLink>
            )
        })
    }

    return (
        <Wrapper>
            {renderLinks(links)}
        </Wrapper>

    )
}

export default ProductsWrapper;